/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/api-v2-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { SocialExportDeleteConnectionMutationResponse, SocialExportDeleteConnectionPathParams, SocialExportDeleteConnection401, SocialExportDeleteConnection403, SocialExportDeleteConnection404 } from "../models/SocialExportDeleteConnection";

export function getSocialExportDeleteConnectionUrl(id: SocialExportDeleteConnectionPathParams["id"]) {
  const res = { method: 'DELETE', url: `/social-export/v1/connections/${id}` as const }
  return res
}

/**
 * @description Disconnects and permanently deletes a connection owned by the authenticated client.
 * @summary Delete a connection by id
 * {@link /social-export/v1/connections/:id}
 */
export async function socialExportDeleteConnection(id: SocialExportDeleteConnectionPathParams["id"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<SocialExportDeleteConnectionMutationResponse, ResponseErrorConfig<SocialExportDeleteConnection401 | SocialExportDeleteConnection403 | SocialExportDeleteConnection404>, unknown>({ method : "DELETE", url : getSocialExportDeleteConnectionUrl(id).url.toString(), ... requestConfig })
  return res.data
}